import { Result, Skeleton } from "antd";

export const ReportContent = ({ loading, error, url }) => {
  const renderContent = () => {
    if (error) {
      return (
        <Result status="error" title="Report Loading Failed" subTitle={error} />
      );
    }

    return (
      <iframe
        key={url}
        src={url}
        title="Report"
        style={{ width: "100%", height: 800, border: 0, flexGrow: 1 }}
        allowFullScreen
      />
    );
  };

  return (
    <div style={{ flexGrow: 1 }}>
      <Skeleton active loading={loading} paragraph={{ rows: 21 }}>
        {renderContent()}
      </Skeleton>
    </div>
  );
};
